const SettlementStatus = {
  UNSETTLED: '미정산',
  SETTLEMENT_COMPLETED: '정산완료',
} as const;

export default SettlementStatus;